export enum BankType {
  INSIDE_CRYPTS = 'inside_crypts',
  INSIDE_NICHES = 'inside_niches',
  OUTSIDE_CRYPTS = 'outside_crypts',
  OUTSIDE_NICHES = 'outside_niches',
}

export const BankTypeShown: Record<BankType, string> = {
  [BankType.INSIDE_CRYPTS]: 'Inside Crypt',
  [BankType.INSIDE_NICHES]: 'Inside Niche',
  [BankType.OUTSIDE_CRYPTS]: 'Outside Crypt',
  [BankType.OUTSIDE_NICHES]: 'Outside Niche',
};
